import {
  formGroupReducer,
  Actions,
  ResetAction,
  createFormGroupState,
  unbox
} from 'ngrx-forms';
import {
  FormsActionTypes,
  RegisterForm,
  SetDocumentId,
  RegisterForms
} from './forms.actions';
import { DxFormState } from './form-state';

/**
 * @deprecated use DxFormState
 */
export type FormState<Form, RawForm> = DxFormState<Form, RawForm>;

export interface FirestoreFormsState {
  [formId: string]: FormState<any, any>;
}

export const firestoreFormsInitialState: FirestoreFormsState = {};

export function defaultBoxFnc<Form, RawForm>(raw: RawForm): Form {
  const clone = { ...(raw as any) };
  if (clone.__createdAt) {
    delete clone.__createdAt;
  }
  if (clone.__archived) {
    delete clone.__archived;
  }
  if (clone.__createdBy) {
    delete clone.__createdBy;
  }
  if (clone.__updatedAt) {
    delete clone.__updatedAt;
  }

  return clone;
}

export function applyFormStateDefaults<RowForm>(
  formId,
  formRegister
): FormState<any, any> {
  return {
    form: createFormGroupState(formId, formRegister.initial),
    successful: null,
    error: null,
    initial: formRegister.initial,
    arrayInitial: formRegister.arrayInitial || null,
    collectionPath: formRegister.collectionPath,
    unbox: formRegister.unbox || unbox,
    load: formRegister.load || [],
    title: formRegister.title || null,
    unique: formRegister.unique || [],
    box: (raw: RowForm) => {
      if (formRegister.box) {
        raw = formRegister.box(raw) as any;
      }
      return defaultBoxFnc(raw);
    },
    validateAndUpdateForm: formRegister.validateAndUpdateForm || null,
    editComponent: formRegister.editComponent || null,
    documentId: null,
    withDefinition: formRegister.withDefinition || false,
    onlyLocal: formRegister.onlyLocal || false
  };
}

export function firestoreFormsReducer<Form, RowForm>(
  state = firestoreFormsInitialState,
  action:
    | Actions<Form>
    | RegisterForm<Form, RowForm>
    | SetDocumentId
    | RegisterForms
): FirestoreFormsState {
  if (action.hasOwnProperty('controlId')) {
    const formId = (action as any).controlId.split('.')[0];
    if (state.hasOwnProperty(formId)) {
      let formState = state[formId];

      switch (action.type) {
        case FormsActionTypes.SetDocumentId:
          state = {
            ...state,
            [formId]: {
              ...formState,
              documentId: action.documentId
            }
          };
          break;

        case ResetAction.TYPE:
          state = {
            ...state,
            [formId]: {
              ...formState,
              successful: null,
              error: null,
              form: createFormGroupState(formState.form.id, formState.initial),
              documentId: null
            }
          };
          break;

        default:
          const form = formGroupReducer(formState.form, action);
          if (form !== formState.form) {
            formState = { ...formState, form };
            if (formState.validateAndUpdateForm) {
              formState = {
                ...formState,
                form: formState.validateAndUpdateForm(formState.form)
              };
            }
            state = { ...state, [formId]: formState };
          }
          break;
      }
    }
  }

  switch (action.type) {
    case FormsActionTypes.RegisterForm:
      return {
        ...state,
        [action.formId]: applyFormStateDefaults<RowForm>(
          action.formId,
          action.payload
        )
      };

    case FormsActionTypes.RegisterForms:
      return {
        ...state,
        ...Object.entries(action.forms)
          .map(([formId, formRegister]) => [
            formId,
            applyFormStateDefaults<RowForm>(formId, formRegister)
          ])
          .reduce(
            (acc, [formId, formRegister]: [string, any]) => ({
              ...acc,
              [formId]: formRegister
            }),
            {}
          )
      };
  }
  return state;
}
